import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/common/logo.svg'


const _hoisted_1 = { class: "l-page" }
const _hoisted_2 = { class: "p-delete-complete l-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "p-delete-complete__ttl c-ttl" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-pwreset__ttl__logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "SHUEISHA ID"
    })
  ]),
  /*#__PURE__*/_createTextVNode("退会 完了")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "p-delete-complete__txt" }, "退会しました。", -1)
const _hoisted_5 = { class: "p-delete-complete__btn" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "トップページへ戻る", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: 'Top' },
          class: "c-btn c-btn--outline"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ]))
}